import { formatNearAmount, parseNearAmount } from '@near-js/utils';
import getConfig from '../config';
import { getWallet, getContract } from '../utils/near-utils';
import { clearKeyNearLocalStorage } from '../utils/helpers';

export const {
  networkId, nodeUrl, contractName, contractMethods, GAS,
} = getConfig();

export { parseNearAmount };

export const initNear = () => async ({ update }) => {
  const { near, wallet, contractAccount } = await getWallet();

  const syncWalletSession = async (nextAccount) => {
    const account = nextAccount || null;
    const signedIn = !!account;
    const walletState = {
      ...wallet,
      signedIn,
      accessKeysCount: 0,
      dappAccessKeysCount: 0,
      accessKeysWarning: '',
      needAccessKeysCleanup: false,
    };
    if (signedIn) {
      walletState.balance = formatNearAmount((await account.getAccountBalance()).available, 2);
      const keyHealth = await wallet.getAccessKeysHealth(account.accountId);
      walletState.accessKeysCount = keyHealth?.count || 0;
      walletState.dappAccessKeysCount = keyHealth?.dappKeysCount || 0;
      walletState.accessKeysWarning = keyHealth?.warning || '';
      walletState.needAccessKeysCleanup = !!keyHealth?.needsCleanup;
      const contract = getContract(account, contractMethods, 0);
      const userProfile = await contract.get_profile({ account_id: account.accountId });
      await update('app', { profile: userProfile });
    }
    await update('', {
      near,
      wallet: walletState,
      contractAccount,
      account,
    });
  };
  const signOut = wallet.signOut;
  wallet.signOut = async () => {
    update('app.errors', '');
    const isSignedOut = await signOut.call(wallet);
    if (!isSignedOut) return false;
    const maintenance = wallet.getLastMaintenance ? wallet.getLastMaintenance() : null;
    if (maintenance?.warning) {
      console.log('walletDeleteKeyOnLogoutWarning', maintenance.warning);
    }
    update('wallet.signedIn', false);
    update('wallet.accessKeysCount', 0);
    update('wallet.dappAccessKeysCount', 0);
    update('wallet.accessKeysWarning', maintenance?.warning || '');
    update('wallet.needAccessKeysCleanup', false);
    update('', { account: null });
    clearKeyNearLocalStorage();
    return true;
  };
  wallet.changeWallet = async () => {
    await signOut.call(wallet);
    clearKeyNearLocalStorage();
    wallet.signIn();
  };
  wallet.signedIn = wallet.isSignedIn();

  const initialAccount = wallet.signedIn ? await wallet.account() : null;
  await syncWalletSession(initialAccount);
  wallet.onAccountChange(syncWalletSession);
  await update('loadedKeys', true);
};
